import type { ReplaceTestIdWithAppOne } from '../../const/testIds';

import type { AppBaseTextProps } from './AppBaseText';
import { AppBaseText } from './AppBaseText';

export type AppTextProps = ReplaceTestIdWithAppOne<AppBaseTextProps>;

export const AppText = (props: AppTextProps) => {
	return <AppBaseText {...props} />;
};
